import { render, staticRenderFns } from "./ItineraryDriverSettings.vue?vue&type=template&id=a72d4336&scoped=true"
import script from "./ItineraryDriverSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ItineraryDriverSettings.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ItineraryDriverSettings.vue?vue&type=style&index=0&id=a72d4336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72d4336",
  null
  
)

export default component.exports